export function mapStatusCodeFromLegacyResponse(resData) {
  if (resData) {
    if (resData.result === -101) { // for ec legacy api
      return 401
    }

    if (resData.code === -101) { // for social legacy api
      return 401
    }
  }

  return 200
}
